import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

/**
 * Floating CTAs visible on every public site page:
 *   • WhatsApp chat (bottom-right) → opens wa.me/919163570... in a new tab
 *   • Request Callback (right edge, vertical) → routes to /contact
 *
 * Both are fixed-positioned and z-50 to stay above page content but BELOW
 * modal overlays (which use z-[60+]).
 */
const WHATSAPP_E164 = "916357033301";         // +91 63570 33301 (no spaces / leading +)
const WHATSAPP_PREFILL = encodeURIComponent(
  "Hello, I'd like to know more about the Nirmal Privilege Card.",
);

export default function FloatingCTAs() {
  return (
    <>
      {/* WhatsApp chat button — bottom right */}
      <a
        href={`https://wa.me/${WHATSAPP_E164}?text=${WHATSAPP_PREFILL}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        title="Chat with us on WhatsApp"
        data-testid="floating-whatsapp-btn"
        className="fixed bottom-5 right-5 z-50 group"
      >
        <span className="flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:scale-110 active:scale-95 transition-transform duration-200">
          {/* Inline WhatsApp glyph (no extra dependency) */}
          <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
            <path d="M19.11 17.21c-.28-.14-1.65-.81-1.9-.91-.26-.09-.45-.14-.63.14-.18.28-.72.91-.88 1.1-.16.18-.32.21-.6.07-.28-.14-1.17-.43-2.23-1.37-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.12.28-.32.42-.48.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.63-1.52-.86-2.08-.23-.55-.46-.47-.63-.48-.16-.01-.35-.01-.53-.01-.18 0-.49.07-.74.35-.25.28-.97.95-.97 2.32 0 1.37 1 2.69 1.14 2.88.14.18 1.98 3.03 4.8 4.13.67.29 1.2.46 1.61.59.68.22 1.3.19 1.78.12.54-.08 1.66-.68 1.89-1.34.23-.66.23-1.23.16-1.34-.07-.12-.25-.18-.53-.32zm-5.06 7.13h-.01a10.46 10.46 0 0 1-5.32-1.46l-.38-.23-3.95 1.03 1.05-3.85-.25-.4a10.4 10.4 0 0 1-1.59-5.56c0-5.74 4.68-10.41 10.45-10.41 2.79 0 5.42 1.09 7.39 3.06a10.36 10.36 0 0 1 3.06 7.36c-.01 5.74-4.69 10.41-10.45 10.41zm8.89-19.31A12.42 12.42 0 0 0 14.05 1.4C7.15 1.4 1.54 7 1.54 13.88c0 2.2.57 4.34 1.67 6.24L1.43 26.6l6.65-1.73a12.51 12.51 0 0 0 5.96 1.51h.01c6.9 0 12.51-5.61 12.51-12.49a12.4 12.4 0 0 0-3.62-8.85z" />
          </svg>
        </span>
        {/* Mobile-only label that fades in on hover (desktop hover preview) */}
        <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#0F2540] text-white text-xs font-semibold px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">
          WhatsApp: +91 63570 33301
        </span>
      </a>

      {/* Request Callback — right edge, vertical pill */}
      <Link
        to="/contact"
        aria-label="Request a callback"
        title="Request a callback"
        data-testid="floating-callback-btn"
        className="fixed right-0 top-1/2 -translate-y-1/2 z-50 flex items-center gap-2 bg-[#1E4F87] hover:bg-[#0F2540] text-white pl-3 pr-2 py-3 rounded-l-2xl shadow-[0_4px_16px_rgba(15,37,64,0.35)] transition-colors"
        style={{ writingMode: "vertical-rl" }}
      >
        <Phone className="h-4 w-4 rotate-90" />
        <span className="text-xs font-bold tracking-wider uppercase">Request callback</span>
      </Link>
    </>
  );
}
